import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { HttpClient, HttpResponse, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { User } from './user';
import { BaseHttpService } from '../base/_base-http.service';
import {of} from 'rxjs/internal/observable/of';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class UserService extends BaseHttpService {

    private user: User;

    getUser(): Observable<any> {
        if (this.user) {
            return of(this.user);
        } else {
            return this.http.get(Config.API + '/user')

                .pipe(map( (user) => {
                  this.storeUser(user);
                  return user;
                }), catchError(this.handleError.bind(this)));
        }
    }

    storeUser(user: any): void {
      this.user = user;
    }

    removeStoredUser(): void {
      this.user = null;
    }

    getInitials(): String {
        return 'RM';
    }
}
